import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { format, parseISO } from 'date-fns';
import logo from '../images/logo_bezh.png';
import CurrentUserContext from '../contexts/CurrentUserContext';
import { CartContext } from '../contexts/cardContext';
import basket from '../images/basket1.PNG';
import icon from '../images/icon.png';
import defImage from '../images/defImage.png';
import { BASE_URL } from '../utils/config';

function Header() {
  const { user, setUser } = useContext(CurrentUserContext);
  const { cart, totalPrice, clearCart, increaseItemAmount, decreaseItemAmount, removeItem, pizzaBoxes } = useContext(CartContext);
  const [currentTime, setCurrentTime] = useState('');
  const [showRegistrationPopup, setShowRegistrationPopup] = useState(false);
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [showCartPopup, setShowCartPopup] = useState(false);
  const [showUserProfilePopup, setShowUserProfilePopup] = useState(false);
  const [showConsentPopup, setShowConsentPopup] = useState(false);
  const [verificationCode, setVerificationCode] = useState('');
  const [isCodeSent, setIsCodeSent] = useState(false);
  const [timer, setTimer] = useState(60);
  const [showCodeInput, setShowCodeInput] = useState(false);
  const [showAddressForm, setShowAddressForm] = useState(false);
  const [cities, setCities] = useState([]);
  const [allStreets, setAllStreets] = useState([]);
  const [filterText, setFilterText] = useState('');
  const [filteredStreets, setFilteredStreets] = useState([]);
  const [showStreetDropdown, setShowStreetDropdown] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [deliveryPrice, setDeliveryPrice] = useState(0);
  const { getProductByName } = useContext(CartContext);
  const [showOrderSuccessPopup, setShowOrderSuccessPopup] = useState(false);
  const [addressData, setAddressData] = useState({
    city: '',
    street: '',
    house: '',
    building: '',
    entrance: '',
    floor: '',
    flat: '',
    comment: ''
  });
  const [formData, setFormData] = useState({
    fullName: '',
    surname:'',
    name: '',
    middleName: '',
    birthday: '',
    phoneNumber: '',
    email: '',
    walletBalances: '',
    consentStatus: '',
    sex: ''
  });
  const [cartData, setCartData] = useState(
    cart.map(product => ({ ...product, amount: 1, comment: '', guests: 1, image: '' }))
  );

  useEffect(() => { // РЕГИСТРАЦИЯ
    if (showRegistrationPopup) {
      const fetchUserData = async () => {
        try {
          const response = await axios.get(`${BASE_URL}/loyalty/iiko/customer/get`);
          setFormData(response.data);
        } catch (error) {
          console.error('Ошибка загрузки данных пользователя:', error);
        }
      };
      fetchUserData();
    }
  }, [showRegistrationPopup]);

  useEffect(() => {
    if (showRegistrationPopup) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [showRegistrationPopup]);

  const updateFormData = (user) => ({
    fullName: `${user?.surname || ''} ${user?.name || ''} ${user?.middleName || ''}`.trim(),
    birthday: user?.birthday || '',
    phoneNumber: user?.phoneNumber || '',
    email: user?.email || '',
    walletBalances: user?.walletBalances || [],
    consentStatus: '',
    sex: user?.sex?.toString() || '',
  });
  
  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem('user'));
    if (storedUser) {
      setUser(storedUser);
      setFormData(updateFormData(storedUser));
    }
  }, [setUser]);
  
  useEffect(() => {
    if (user) {
      localStorage.setItem('user', JSON.stringify(user));
      setFormData(updateFormData(user));
    } else {
      localStorage.removeItem('user');
    }
  }, [user]);

  useEffect(() => { // ВРЕМЯ
    const updateCurrentTime = () => {
      const daysOfWeek = ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'];
      const today = new Date().getDay();
      const hours = new Date().getHours();
      const minutes = new Date().getMinutes();
      const formattedTime = `${hours}:${minutes < 10 ? '0' + minutes : minutes}`;
      let workingHours = '22:30';
      if (today === 5 || today === 6) {
        workingHours = '23:30';
      }
      setCurrentTime(`${daysOfWeek[today]} ${formattedTime}\nПринимаем заказы с 10:00 до ${workingHours}`);
    };
    updateCurrentTime();
    const intervalId = setInterval(updateCurrentTime, 60000);
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => { // КОРЗИНА
    setCartData(cart.map(product => ({
      productId: product.productId,
      name: product.name,
      image: product.image,
      price: product.price,
      amount: product.amount || 1,
      modifiers: product.modifiers || [],
      guests: product.guests || 1,
      comment: product.comment || ''
    })));
  }, [cart]);

  useEffect(() => { // СПИСОК ГОРОДОВ
    const fetchCities = async () => {
      try {
        const response = await axios.post(`${BASE_URL}/cities`);
        const cityItems = response.data.cities[0].items;
        setCities(cityItems);
      } catch (error) {
        console.error('Error fetching cities:', error);
      }
    };
    fetchCities();
  }, [showAddressForm]);

  const openLoginPopup = () => {
    setShowLoginPopup(true);
    setShowCartPopup(false)
  }
  const openRegistrationPopup = () => {
    setShowRegistrationPopup(true);
    setShowLoginPopup(false);
  };
  const openCartPopup = () => {
    setShowCartPopup(true);
  };
  const openUserProfilePopup = () => {
    setFormData({
      fullName: `${user?.surname || ''} ${user?.name || ''} ${user?.middleName || ''}`.trim(),
      birthday: user?.birthday ? getDateWithoutTime(user.birthday) : '',
      phoneNumber: user?.phoneNumber || '',
      email: user?.email || '',
      walletBalances: user.walletBalances || []
    });
    setShowUserProfilePopup(true);
    setShowRegistrationPopup(false);
    setShowLoginPopup(false);
    setShowCartPopup(false);
  };
  const openConsentPopup = () => {
    setShowConsentPopup(true);
  };
  const closePopups = () => {
    setShowRegistrationPopup(false);
    setShowLoginPopup(false);
    setShowCartPopup(false);
    setShowUserProfilePopup(false);
    setShowConsentPopup(false);
    setErrorMessage('');
    setVerificationCode('');
    setIsCodeSent(false);
    setShowCodeInput(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "sex") {
      setFormData((prevState) => ({
        ...prevState,
        sex: value
      }));
      return;
    }
    if (name === "phoneNumber") {
      let formattedValue = value;
      if (formattedValue === "+7") {
      } else if (formattedValue.startsWith("+") && formattedValue[1] !== "7") {
        formattedValue = "+7" + formattedValue.slice(1);
      } else if (formattedValue === "7") {
        formattedValue = "+7";
      } else if (formattedValue === "8") {
        formattedValue = "+7";
      } else if (formattedValue === "9" || formattedValue.startsWith("9")) {
        formattedValue = "+7" + formattedValue;
      } else if (!formattedValue.startsWith("+7") && !formattedValue.startsWith("+") && !formattedValue.startsWith("9") && formattedValue !== "8") {
        formattedValue = "+7" + formattedValue;
      }
      setFormData((prevState) => ({
        ...prevState,
        [name]: formattedValue
      }));
      return;
    }
    setFormData((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };

  const sendVerificationCode = async (phoneNumber) => {
    try {
      await axios.post(`${BASE_URL}/auth/request-code`, { phone: phoneNumber });
      setIsCodeSent(true);
      setShowCodeInput(true);
      startTimer();
    } catch (error) {
      console.error('Ошибка при отправке СМС. Попробуйте позже.');
    }
  };
  const startTimer = () => {
    setTimer(600);
    timerInterval = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          clearInterval(timerInterval);
          setShowCodeInput(false);
          return 600;
        }
        return prev - 1;
      });
    }, 1000);
  };
  let timerInterval;

  const handleOrderSubmit = async (event) => {
    event.preventDefault();
  if (!addressData.city || !addressData.street || !addressData.house) {
    alert("Пожалуйста, заполните все обязательные поля (город, улица, дом).");
    return;
  }
  if (cart.length === 0) {
    alert("Корзина пуста! Добавьте хотя бы один товар в корзину.");
    return;
  }
    const items = cartData.map(item => ({
      type: 'Product',
      amount: item.amount || 1,
      productId: item.productId,
      modifiers: (item.modifiers || []).map(mod => ({
        productId: mod.productId,
        amount: mod.amount || 1,
        productGroupId: mod.productGroupId || '',
      })),
      comment: item.comment || ''
    }));
    if (pizzaBoxes.pizzaBox30 && pizzaBoxes.pizzaBox30.amount > 0) {
      items.push({
        type: 'Product',
        amount: pizzaBoxes.pizzaBox30.amount,
        productId: pizzaBoxes.pizzaBox30.id,
        productGroupId: pizzaBoxes.pizzaBox30.productGroupId || '',
        comment: 'Коробка для пиццы 30 см'
      });
    }
    if (pizzaBoxes.pizzaBox40 && pizzaBoxes.pizzaBox40.amount > 0) {
      items.push({
        type: 'Product',
        amount: pizzaBoxes.pizzaBox40.amount,
        productId: pizzaBoxes.pizzaBox40.id,
        productGroupId: pizzaBoxes.pizzaBox40.productGroupId || '',
        comment: 'Коробка для пиццы 40 см'
      });
    }
    const orderData = {
      phone: formData.phoneNumber,
      comment: addressData.comment || '',
      guests: formData.guests || 1,
      items: items,
      address: {
        street: { id: addressData.street.id },
        house: addressData.house,
        building: addressData.building || '',
        flat: addressData.flat || '',
        entrance: addressData.entrance || '',
        floor: addressData.floor || '',
        doorphone: addressData.doorphone || ''
      },
      customer: {
        id: user.id,
        type: 'regular'
      }
    };
    try {
      const response = await axios.post(`${BASE_URL}/deliveries/create`, orderData);
      console.log('Заказ успешно отправлен:', response);
      setShowCartPopup(false);
      clearCart();
      setShowOrderSuccessPopup(true);
    } catch (error) {
      console.error('Ошибка при отправке заказа:', error);
    }
  };

  const handleStreetSearch = async (cityId, query) => {
    if (!cityId) {
      console.error("City ID is required but not provided.");
      return;
    }
    try {
      const response = await axios.post(`${BASE_URL}/streets/by_city`, {
        id: cityId,
        name: query || '',
      });
      const streetItems = response.data.streets;
      setAllStreets(streetItems);
      setFilteredStreets(streetItems);
    } catch (error) {
      console.error("Error fetching streets:", error);
    }
  };

  const getDateWithoutTime = (dateString) => {
    return format(parseISO(dateString), 'yyyy-MM-dd');
  };

  const handleLoginSubmit = (e) => {
    e.preventDefault();
    sendVerificationCode(formData.phoneNumber);
  };

  const verifyCode = async () => {
    try {
      await axios.post(`${BASE_URL}/auth/verify-code`, {
        phone: formData.phoneNumber,
        code: verificationCode
      });
      setErrorMessage('');
      const userInfo = await axios.post(`${BASE_URL}/loyalty/iiko/customer/info`, {
        phone: formData.phoneNumber
      });
      if (
          userInfo.data.surname &&
          userInfo.data.name &&
          userInfo.data.birthday &&
          userInfo.data.consentStatus === 1 &&
          (userInfo.data.sex === 1 || userInfo.data.sex === 2)
        ) {
        setUser({
          ...userInfo.data,
          phoneNumber: formData.phoneNumber
        });
        closePopups();
      } else {
        setFormData({
          ...formData,
          ...userInfo.data
        });
        openRegistrationPopup();
      }
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 400 && data.errorCode === 'Validation_IncorrectPhone') {
          openRegistrationPopup();
        } else if (status === 401) {
          setErrorMessage('Введен неверный код. Повторите попытку.');
        } else {
          setErrorMessage('Произошла ошибка. Повторите попытку позже.');
        }
      } else {
        setErrorMessage('Ошибка сети. Проверьте соединение.');
      }
    }
  };
  
  const handleUserProfileSubmit = async (e) => {
    e.preventDefault();
    let surname, name, middleName;
    if (formData.fullName) {
      const nameParts = formData.fullName.split(' ');
      surname = nameParts[0] || '';
      name = nameParts[1] || '';
      middleName = nameParts.length > 2 ? nameParts.slice(2).join(' ') : '';
    } else {
      surname = formData.surname || '';
      name = formData.name || '';
      middleName = formData.middleName || '';
    }
    const requestData = {
      phone: formData.phoneNumber,
      name,
      surname,
      middleName: middleName || '',
      birthday: formData.birthday,
      email: formData.email,
      consentStatus: '1',
      sex: formData.sex ? parseInt(formData.sex, 10) : null,
    };
    if (formData.sex) {
      requestData.sex = parseInt(formData.sex, 10);
    }
    try {
      const response = await axios.post(`${BASE_URL}/loyalty/iiko/customer/create_or_update`, requestData);
      const userInfoResponse = await axios.post(`${BASE_URL}/loyalty/iiko/customer/info`, { phone: formData.phoneNumber });
      const updatedUser = { ...userInfoResponse.data, phoneNumber: formData.phoneNumber };
      setUser(updatedUser);
      setFormData({
        fullName: `${updatedUser.surname || ''} ${updatedUser.name || ''} ${updatedUser.middleName || ''}`.trim(),
        birthday: updatedUser.birthday || '',
        phoneNumber: updatedUser.phoneNumber || '',
        email: updatedUser.email || '',
        sex: updatedUser.sex?.toString() || ''
      });
      closePopups();
    } catch (error) {
      console.error('Error updating user profile:', error);
    }
  };

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem('user');
    closePopups();
    setFormData({
      fullName: '',
      birthday: '',
      phoneNumber: '',
      email: ''
    });
    clearInterval(timerInterval);
    setTimer(60);
    setIsCodeSent(false);
    setShowCodeInput(false);
    setVerificationCode('');
  };

  const handleCityChange = (selectedCity) => {
    setAddressData({
        ...addressData,
        city: selectedCity,
        street: '',
    });
    setAllStreets([]);
    setFilteredStreets([]);
    setFilterText('');
    setShowStreetDropdown(false);

    if (selectedCity) {
        handleStreetSearch(selectedCity, '');
        updateDeliveryPrice(selectedCity, totalPrice);
    }
};

// Функция для обновления стоимости доставки
const updateDeliveryPrice = (selectedCity, currentTotal) => {
    const cityName = cities.find(city => city.id === selectedCity)?.name || '';
    const deliveryProduct = getProductByName(`Доставка - ${cityName}`);
    let newDeliveryPrice = deliveryProduct ? deliveryProduct.price : 0;

    if ((cityName === "Верхний Тагил" && currentTotal > 2000) ||
        (cityName === "Кировград" && currentTotal > 350) ||
        (cityName === "Невьянск" && currentTotal > 2000) ||
        (cityName === "Лёвиха" && currentTotal > 3500) ||
        (cityName === "Н-рудянка" && currentTotal > 2000) ||
        (cityName === "Цементный" && currentTotal > 2000) ||
        (cityName === "Шурала" && currentTotal > 1700) ||
        (cityName === "Карпушиха" && currentTotal > 2500)) {
        newDeliveryPrice = 0; // Доставка бесплатная
    }

    setDeliveryPrice(newDeliveryPrice);
};

useEffect(() => {
    if (addressData.city) {
        updateDeliveryPrice(addressData.city, totalPrice);
    }
}, [cart, totalPrice]);

  return (
    <header>
      <div className="header__snow"></div>
      <div className="header__content">
        <div>
          <a href="/"><img className="header__logo" src={logo} alt="Логотип" /></a>
        </div>
        <div className="header__contact">
          <p className="header__time header__hide">{currentTime}</p>
          <a className="header__phone" href="tel:+79226002900">&#x1F4DE; <p className='header__hide'>+792-2600-2900</p></a>
        </div>
        <div className="header__menu">
          {user ? (
            <div className="header__menu-item" onClick={openUserProfilePopup}>
              <img className='header__menu-item-image' src={icon} alt='Личный кабинет' />
            </div>
            ) : (
              <div className="header__menu-item" onClick={openLoginPopup}>Войти</div>
          )}
          <button className="header__menu-item" onClick={openCartPopup}>
            <div className="header__basket-wrapper">
              <img className="header__basket" src={basket} alt="Корзина"/>
            </div>
            <p>{totalPrice + deliveryPrice}₽</p>
          </button>
        </div>
      </div>

      {showLoginPopup && (
        <div className="popup__overlay">
          <div className="popup-login" onClick={(e) => e.stopPropagation()}>
            <h2 className='popup-login__heading'>Для заказа войдите в личный кабинет</h2>
            <form className='popup-login__form' onSubmit={handleLoginSubmit}>
              <label>
                Телефон
                <input
                  type="tel"
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  placeholder="Введите номер телефона, подтверждение придет в СМС"
                  required
                />
              </label>
              {errorMessage && (
                <div className="error-message" style={{ color: 'red' }}>
                {errorMessage}
                </div>
              )}
              {!showCodeInput ? (
                <button
                  className='popup-login__button popup-login__button-green'
                  type="submit"
                >
                  Получить код
                </button>
              ) : (
                <>
                  <p>Код действителен еще {timer} секунд</p>
                  <label>
                    Введите код подтверждения:
                    <input
                      type="text"
                      value={verificationCode}
                      onChange={(e) => setVerificationCode(e.target.value)}
                      placeholder="Введите код из СМС здесь"
                      required
                    />
                  </label>
                  <button
                    className='popup-login__button popup-login__button-green'
                    type="button"
                    onClick={verifyCode}
                  >
                    Подтвердить
                  </button>
                </>
              )}
              <button className='popup-login__button' type="button" onClick={closePopups}>Отмена</button>
            </form>
          </div>
        </div>
      )}

      {showRegistrationPopup && (
          <div className="popup-registration" onClick={(e) => e.stopPropagation()}>
            <h2 className='popup-registration__heading'>Еще немного формальностей</h2>
            <p className='popup-registration__heading'>Заполните ваши данные, чтобы мы могли принимать у вас заказы</p>
            <form className='popup-registration__form' onSubmit={handleUserProfileSubmit}>
              <label>
                Фамилия
                <input
                  type="text"
                  name="surname"
                  value={formData.surname}
                  onChange={handleChange}
                  placeholder="Фамилия"
                  required
                />
              </label>
              <label>
                Имя
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Имя"
                  required
                />
              </label>
              <label>
                Отчество
                <input
                  type="text"
                  name="middleName"
                  value={formData.middleName}
                  onChange={handleChange}
                  placeholder="Отчество"
                />
              </label>
              <label>
                Дата рождения:
                <input
                  type="date"
                  name="birthday"
                  value={formData.birthday}
                  onChange={handleChange}
                  required
                />
              </label>
              <label>
                Электронная почта:
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="example@pochta.ru"
                />
              </label>
              <div className='popup-registration__form-sex'>
                <label>
                  <input
                    type="radio"
                    name="sex"
                    value="1"
                    checked={formData.sex === '1'}
                    onChange={handleChange}
                    required
                  />
                  Мужской
                </label>
                <label>
                  <input
                    type="radio"
                    name="sex"
                    value="2"
                    checked={formData.sex === '2'}
                    onChange={handleChange}
                    required
                  />
                  Женский
                </label>
              </div>
              <label>
                Номер телефона:
                <input
                  type="tel"
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  disabled
                  placeholder="Телефон"
                  required
                />
              </label>
              <div className='popup-registration__consent'>
                <p className='popup-registration__consent-p'>Нажимая на кнопку "Сохранить", вы даете</p>
                <button type="button" className="popup-registration__consent-button" onClick={openConsentPopup}>
                  Согласие на обработку и хранение персональных данных
                </button>
              </div>
              <button className='popup-registration__button popup-registration__button_green' type="submit">Сохранить</button>
              {errorMessage && <p className="error">{errorMessage}</p>}
              <button className='popup-registration__button' type="button" onClick={closePopups}>Отмена</button>
            </form>
          </div>
      )}

      {showConsentPopup && (
        <div className="popup__overlay" onClick={() => setShowConsentPopup(false)}>
          <div className="popup-consent" onClick={(e) => e.stopPropagation()}>
            <h2 className='popup-consent__h2'>Согласие на обработку данных</h2>
            <p>
              Я, далее — «Субъект Персональных Данных», даю свое согласие ИП Забудский Олег Геннадьевич на обработку моих персональных данных. Согласие касается фамилии, имени, отчества, данных о поле, дате рождения, номере телефона, адреса электронной почты, адреса места жительства. Я даю согласие на использование персональных данных для регистрации Субъекта Персональных Данных в базе данных Компании с последующим направлением Субъекту Персональных Данных почтовых сообщений и смс-уведомлений, в том числе рекламного содержания, от Компании, информационных и новостных рассылок, приглашений на мероприятия Компании и другой информации рекламно-новостного содержания, а также с целью подтверждения личности Субъекта Персональных Данных при оформлении заказа. Согласие выдано на обработку персональных данных смешанным (автоматизированным и неавтоматизированным) способом. В процессе обработки персональных данных Оператор вправе осуществлять: сбор; запись; систематизацию; накопление; хранение; уточнение (обновление, изменение); извлечение; использование; передачу (распространение, предоставление, доступ); обезличивание; блокирование; удаление; уничтожение персональных данных Пользователя. Датой выдачи согласия на обработку персональных данных Субъекта Персональных Данных является дата отправки регистрационной веб-формы с Сайта Компании www.art-bazar.am. До моего сведения доведено, что ИП Забудский Олег Геннадьевич гарантирует обработку моих персональных данных в соответствии с действующим законодательством Российской Федерации. Срок действия данного согласия не ограничен. Согласие может быть отозвано в любой момент по моему письменному заявлению. Подтверждаю, что, давая согласие, я действую без принуждения, по собственной воле и в своих интересах.
            </p>
            <button className="popup-consent__button" onClick={() => setShowConsentPopup(false)}>
              Закрыть
            </button>
          </div>
        </div>
      )}

      {showUserProfilePopup && (
        <div className="popup-user-profile" onClick={(e) => e.stopPropagation()}>
          <h2 className='popup-user-profile__heading'>Ваши персональные данные</h2>
          <form className='popup-user-profile__form' onSubmit={handleUserProfileSubmit}>
            <div className='popup-user-profile__form-profile'>
              <label>
                Фамилия Имя Отчество
                <input
                  type="text"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  placeholder="ФИО"
                  required
                />
              </label>
              <label>
                Дата рождения:
                <input
                  type="date"
                  name="birthday"
                  value={formData.birthday}
                  onChange={handleChange}
                  disabled
                  required
                />
              </label>
            </div>
            <div className='popup-user-profile__form-profile'>
              <label>
                Номер телефона:
                <input
                  type="tel"
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  disabled
                  placeholder="Телефон"
                  required
                />
              </label>
              <label>
                Электронная почта:
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Email"
                  required
                />
              </label>
            </div>
            <button
              className='popup-user-profile__button popup-user-profile__button_green'
              type="submit"
            >
              Сохранить
            </button>
            <button
              className='popup-user-profile__button'
              type="button"
              onClick={closePopups}
            >
              Отмена
            </button>
          </form>
          <h3 className='popup-user-profile__heading'>Накоплено бонусов</h3>
          <div className=''>
            {formData?.walletBalances?.[0]?.balance || 0} рублей
          </div>
          <button
            className="popup-user-profile__button"
            onClick={handleLogout}
            type='button'
          >
            Выйти из аккаунта
          </button>
        </div>
      )}

      {showCartPopup && (
        <div className="popup-cart" onClick={(e) => e.stopPropagation()}>
          <h2 className='popup-cart__heading'>Оформление заказа</h2>
          <h3 className='popup-cart__heading'>Куда привезти?</h3>
          <div className="popup-cart__adress">
            <label className="popup-cart__adress-item popup-cart__adress-item1">В какой город?
              <select
                name="city"
                value={addressData.city}
                onChange={(e) => handleCityChange(e.target.value)}
              >
                <option value="">Выберите город</option>
                {cities.length > 0 ? (
                  cities.map((city) => (
                    <option key={city.id} value={city.id}>
                      {city.name}
                    </option>
                  ))
                ) : (
                  <option>Загрузка...</option>
                )}
              </select>
            </label>
            <label className="popup-cart__adress-item popup-cart__adress-item2">Улица
              <input
                type="text"
                name="street"
                value={filterText}
                onFocus={() => {
                  if (!addressData.city) {
                    alert('Сначала выберите город.');
                    return;
                  }
                  if (!allStreets.length) {
                    handleStreetSearch(addressData.city, '');
                  }
                  setShowStreetDropdown(true);
                }}
                onChange={(e) => {
                  if (!addressData.city) {
                    alert('Сначала выберите город.');
                    return;
                  }
                  const value = e.target.value;
                  setFilterText(value);
                  const filtered = allStreets.filter((street) =>
                    street.name.toLowerCase().includes(value.toLowerCase())
                  );
                  setFilteredStreets(filtered);
                }}
                placeholder="Начните ввод для выбора улицы"
                disabled={!addressData.city}
                autoComplete="off"
              />
              {showStreetDropdown && (
                <div className="popup-cart__adress-item2-dropdown">
                  <select
                    size="5"
                    onChange={(e) => {
                      const selectedStreet = allStreets.find(
                        (street) => street.name === e.target.value
                      );
                      setAddressData({
                        ...addressData,
                        street: { id: selectedStreet.id, name: selectedStreet.name },
                      });
                      setFilterText(selectedStreet.name);
                      setShowStreetDropdown(false);
                    }}
                  >
                    {filteredStreets.map((street) => (
                      <option key={street.id} value={street.name}>
                        {street.name}
                      </option>
                    ))}
                  </select>
                  {!filteredStreets.length && <p>Улицы не найдены</p>}
                </div>
              )}
            </label>
            <label className='popup-cart__adress-item popup-cart__adress-item3'>Дом
              <input
                type="text"
                name="house"
                value={addressData.house}
                onChange={(e) => setAddressData({...addressData, house: e.target.value})}
                placeholder="Номер дома"
              />
            </label>
            <label className='popup-cart__adress-item popup-cart__adress-item4'>Корпус
              <input 
                type="text"
                name="building"
                value={addressData.building}
                onChange={(e) => setAddressData({...addressData, building: e.target.value})}
                placeholder="Корпус (если есть)"
              />
            </label>
            <label className='popup-cart__adress-item popup-cart__adress-item5'>Подъезд
              <input
                type="text"
                name="entrance"
                value={addressData.entrance}
                onChange={(e) => setAddressData({...addressData, entrance: e.target.value})}
                placeholder="Подъезд"
              />
            </label>
            <label className='popup-cart__adress-item popup-cart__adress-item6'>Этаж
              <input
                type="text"
                name="floor"
                value={addressData.floor}
                onChange={(e) => setAddressData({...addressData, floor: e.target.value})}
                placeholder="Этаж"
              />
            </label>
            <label className='popup-cart__adress-item popup-cart__adress-item7'>Квартира
              <input
                type="text"
                name="flat"
                value={addressData.flat}
                onChange={(e) => setAddressData({...addressData, flat: e.target.value})}
                placeholder="Квартира"
              />
            </label>
            <label className='popup-cart__adress-item popup-cart__adress-item8'>Комментарий для курьера
              <textarea
                name="comment"
                value={addressData.comment}
                onChange={(e) => setAddressData({...addressData, comment: e.target.value})}
                placeholder="Здесь можно оставить комментарий для курьера"
              >
              </textarea>
            </label>
          </div>
          <div className='popup-cart__total'>
            <div className='popup-cart__spoons'>
              <h3 className='popup-cart__heading popup-cart__heading_little'>Сколько приборов положить?</h3>
              <div>
                <button
                  className='popup-cart__button-plus popup-cart__button-plus-minus'
                  onClick={() => {
                    const guests = formData.guests || 1;
                    if (guests > 1) setFormData({ ...formData, guests: guests - 1 });
                  }}
                >
                  -
                </button>
                <span>{formData.guests || 1}</span>
                <button
                  className='popup-cart__button-plus popup-cart__button-plus-plus'
                  onClick={() => {
                    const guests = formData.guests || 1;
                    setFormData({ ...formData, guests: guests + 1 });
                  }}
                >
                  +
                </button>
              </div>
            </div>
            <div className='popup-cart__delivery'>
              <h3>Стоимость доставки: {deliveryPrice} ₽</h3>
            </div>
            <h3 className='popup-cart__heading'>Общая стоимость: {totalPrice + deliveryPrice} ₽</h3>
          </div>
          <button
            className='popup-cart__button-order'
            onClick={(e) => {
              if (user) {
                handleOrderSubmit(e);;
              } else {
                openLoginPopup();
              }
            }}
          >
            Оформить заказ
          </button>
          <button
            className='popup-cart__button-add'
            type="button"
            onClick={closePopups}
          >
            Нажмите здесь, если нужно дополнить заказ
          </button>
          {cart.length === 0 ? (
            <p>Корзина пуста</p>
            ) : (
              <ul className='popup-cart__products'>
                {cart.map((product) => (
                  <li className='popup-cart__product' key={product.key}>
                    <img className='popup-cart__product1' src={product.image || defImage} alt={product.name} /> 
                    <p className='popup-cart__product2'>{product.name}</p>
                    <div className='popup-cart__product3' style={{display: 'flex'}}>
                      <button className='popup-cart__button-plus popup-cart__button-plus-minus' onClick={() => decreaseItemAmount(product.key)}></button>
                      <span>{product.amount}</span>
                      <button className='popup-cart__button-plus popup-cart__button-plus-plus' onClick={() => increaseItemAmount(product.key)}></button>
                      <button
                        className="popup-cart__button-remove"
                        onClick={() => {
                          removeItem(product.key);
                        }}
                      >
                      </button>
                    </div>
                    <p className='popup-cart__product4'> 
                      {(product.price + (product.modifiers?.reduce((sum, modifier) => sum + modifier.price, 0) || 0)) * product.amount} ₽
                    </p>
                    <label className='popup-cart__adress-item popup-cart__product5'>
                      <textarea
                        name="comment"
                        value={product.comment || ''}
                        onChange={(e) => {
                          const newCart = [...cart];
                          const index = cart.findIndex((item) => item.key === product.key);
                          newCart[index].comment = e.target.value;
                          setCartData(newCart);
                        }}
                        placeholder="Здесь можно оставить комментарий для повара"
                      />
                    </label>
                    {product.modifiers && product.modifiers.length > 0 && (
                      <ul className='popup-cart__product6'>
                        {product.modifiers.map((modifier, modIndex) => (
                          <li key={modIndex}>
                            {modifier.name} - {modifier.price} ₽
                          </li>
                        ))}
                      </ul>
                    )}      
                  </li>
                ))}
                {pizzaBoxes.pizzaBox30 && (
                  <li className='popup-cart__pizza-box' key={pizzaBoxes.pizzaBox30.id}>
                    В заказ добавлена {pizzaBoxes.pizzaBox30.name}: {pizzaBoxes.pizzaBox30.amount} шт. - {pizzaBoxes.pizzaBox30.price * pizzaBoxes.pizzaBox30.amount}₽
                  </li>
                )}
                {pizzaBoxes.pizzaBox40 && (
                  <li className='popup-cart__pizza-box' key={pizzaBoxes.pizzaBox40.id}>
                    В заказ будет добавлена {pizzaBoxes.pizzaBox40.name}: {pizzaBoxes.pizzaBox40.amount} шт. - {pizzaBoxes.pizzaBox40.price * pizzaBoxes.pizzaBox40.amount}₽
                  </li>
                )}
              </ul>
          )}
        </div>
      )}
      {showOrderSuccessPopup && (
        <div className="popup__overlay" onClick={() => setShowOrderSuccessPopup(false)}>
          <div className="popup-order-success" onClick={(e) => e.stopPropagation()}>
            <h2 className='popup-order-success__heading'>Заявка принята!</h2>
            <p className='popup-order-success__text'>Скоро вам позвонит оператор для подтверждения заказа.</p>
            <button className='popup-order-success__close-button' onClick={() => setShowOrderSuccessPopup(false)}>✖</button>
          </div>
        </div>
      )}
    </header>
  );
}

export default Header;
